import React from 'react';
import { EyeOff, User } from 'lucide-react';

// Explicit two-way choice so posting never feels "stuck" on one identity.
export const IdentityToggle = ({ anonymous, onChange, name, dark = false, testId = 'identity-toggle', verb = 'Post' }) => {
  const first = (name || 'you').split(' ')[0];
  const base = 'inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-medium transition-colors';
  const on = dark ? 'bg-[#D6AD60] text-stone-900' : 'bg-stone-800 text-white';
  const off = dark ? 'text-white/70 hover:bg-white/10' : 'text-stone-600 hover:bg-stone-200';
  return (
    <div className={`inline-flex items-center rounded-full p-0.5 ${dark ? 'bg-white/10' : 'bg-stone-100'}`} role="radiogroup" aria-label={`${verb} as`} data-testid={testId}>
      <button type="button" role="radio" aria-checked={!anonymous} onClick={() => onChange(false)} className={`${base} ${!anonymous ? on : off}`} data-testid={`${testId}-self`}>
        <User className="w-3 h-3" /> {verb} as {first}
      </button>
      <button type="button" role="radio" aria-checked={anonymous} onClick={() => onChange(true)} className={`${base} ${anonymous ? on : off}`} data-testid={`${testId}-anon`}>
        <EyeOff className="w-3 h-3" /> Anonymous
      </button>
    </div>
  );
};
